<h1 mat-dialog-title><span fxFlex>Potenziali Travel Advisors</span><small style="font-weight: normal;"><i>dati
            aggiornati ogni ora</i></small></h1>

<div *ngIf="!loading">
    <div>
        <mat-form-field appearance="standard" style="padding: 0px 15px 0 15px;" fxFlex>
            <mat-label>Cerca nome, email o destinazione...</mat-label>
            <mat-icon matPrefix>search</mat-icon>
            <input matInput placeholder="nome, email o destinazione..." [(ngModel)]="searchTerm" />
        </mat-form-field>
    </div>
    <div style="height: 60vh;" class="mat-dialog-content" *ngIf="filter(searchTerm); let filteredTravelAdvisors">
        <mat-selection-list [(ngModel)]="selectedOptions">
            <mat-list-option *ngFor="let travelAdvisor of filteredTravelAdvisors" checkboxPosition="before"
                color="primary" [value]="travelAdvisor.id" [selected]="userAlreadyHasAProposal(travelAdvisor.id)"
                [disabled]="userAlreadyHasAProposal(travelAdvisor.id)"
                style="height: auto; min-height: 34px; border-bottom: 1px solid #b0b0b0;" [ngClass]="{
                    'warning-yellow': travelAdvisor.pendingAssignmentProposalsCount>0,
                    'warning-red': travelAdvisor.pendingItinerariesCount>0
                }" [fxHide]="!travelAdvisor.visible">
                <div fxLayout="row" fxLayoutAlign="center center" style="padding: 8px 0">
                    <div fxFlex fxLayout="column">
                        <div>
                            <ng-container *ngIf="travelAdvisor.displayName">{{travelAdvisor.displayName}} &mdash;
                            </ng-container>{{travelAdvisor.email}}
                        </div>
                        <small>
                            <ng-container *ngIf="travelAdvisor.itinerariesCount>=0">{{travelAdvisor.itinerariesCount}}
                                itinerari realizzati</ng-container>
                            <ng-container *ngIf="travelAdvisor.pendingItinerariesCount>0"> &mdash; itinerario in corso
                            </ng-container>
                            <ng-container *ngIf="travelAdvisor.pendingAssignmentProposalsCount>0"> &mdash; proposta di
                                realizzazione itinerario in attesa di risposta</ng-container>
                        </small>
                    </div>
                    <div class="destinations" fxFlex
                        [innerHtml]="travelAdvisor.destinations ? travelAdvisor.destinations : '?'">
                    </div>
                </div>

            </mat-list-option>
        </mat-selection-list>
        <div class="count"><a *ngIf="searchTerm" href="javascript:void(0)" (click)="searchTerm=null">Cancella filtro di
                ricerca</a>
            <ng-container *ngIf="selectedOptions?.length>0">
                &mdash; In totale {{selectedOptions.length}} potenziali Travel Advisors.</ng-container>
        </div>
    </div>
</div>

<div mat-dialog-actions *ngIf="!loading">
    <span fxFlex></span>
    <button class="proposal-button" mat-raised-button color="primary" (click)="ok()">
        Ok
    </button>
</div>

<div *ngIf="loading">
    <p style="text-align: center">...attendi un attimo...</p>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>